/**
 * Promo banner carousel — troca automática a cada 5s.
 */
(function () {
  'use strict';

  var INTERVAL = 5000;

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initCarousel(root) {
    if (!root || root.dataset.promoReady === '1') return;
    var slides = root.querySelectorAll('[data-promo-slide]');
    if (slides.length < 2) return;

    root.dataset.promoReady = '1';
    var dots = root.querySelectorAll('[data-promo-dot]');
    var ms = parseInt(root.getAttribute('data-interval'), 10) || INTERVAL;
    var index = 0;
    var timer = null;

    function show(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].setAttribute('aria-selected', 'false');
      }
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-selected', 'true');
      }
    }

    function start() {
      if (prefersReducedMotion()) return;
      stop();
      timer = setInterval(function () {
        show(index + 1);
      }, ms);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-promo-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
